//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { EventBus } from '../../EventBus/EventBus.js'

import OrderAdmittanceGeneralInfo from './OrderAdmittanceGeneralInfo.vue'
import OrderAdmittanceIssuance from './OrderAdmittanceIssuance.vue'
import OrderAdmittanceProlongation from './OrderAdmittanceProlongation.vue'
import OrderAdmittanceClosing from './OrderAdmittanceClosing.vue'
import OrderAdmittanceReception from './OrderAdmittanceReception.vue'
import OrderAdmittanceAdmittingAndSenior from './OrderAdmittanceAdmittingAndSenior.vue'
import OrderAdmittancePerformers from './OrderAdmittancePerformers.vue'
import OrderAdmittanceWorks from './OrderAdmittanceWorks.vue'
import OrderAdmittanceButtons from './OrderAdmittanceButtons.vue'
import OrderAdmittanceReceptionImages from './OrderAdmittanceReceptionImages.vue'

export default {
  components: {
    OrderAdmittanceGeneralInfo,
    OrderAdmittanceIssuance,
    OrderAdmittanceProlongation,
    OrderAdmittanceClosing,
    OrderAdmittanceReception,
    OrderAdmittanceAdmittingAndSenior,
    OrderAdmittancePerformers,
    OrderAdmittanceWorks,
    OrderAdmittanceButtons,
    OrderAdmittanceReceptionImages
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      orderAdmittance: {},
      orderAdmittanceStr: '',
      loading: false,
      collapsePanel: [false, false, false, false, false, false, false, false, false],
      openAll: false
    }
  },
  watch: {
    '$route.params.id': {
      handler: function () {
        if (this.$route.params.id === 'template') {
          this.orderAdmittance.brigadeId = this.$route.query.brigade
          this.orderAdmittance.templateId = this.$route.query.template
          this.orderAdmittance.date = this.$route.query.date
          this.orderAdmittance.template = true
          this.updateOrderAdmittanceTemplate()
        } else {
          this.orderAdmittance.id = this.$route.params.id
          this.updateOrderAdmittance()
        }
      },
      immediate: true
    }
  },
  created: function () {
    if (this.isMobile) {
      this.collapsePanel[4] = true
    } else {
      this.collapsePanel[0] = true
    }
  },
  methods: {
    getColorState: function () {
      let color = 'white'
      if (this.orderAdmittance) {
        const state = this.orderAdmittance.state
        switch (state) {
          case 'AD1':
          case 'AD2':
            color = 'blue'
            break
          case 'AD3':
            color = 'light-green-13'
            break
          case 'AD4':
            color = 'orange'
            break
          case 'AD5':
          case 'AD6':
            color = 'green'
            break
          case 'AD7':
            color = 'red'
            break
          default:
            break
        }
      }
      return color
    },
    openAllMethod: function () {
      const sign = this.openAll
      this.openAll = !sign
      this.collapsePanel = this.collapsePanel.map((value) => !sign)
    },
    updateOrderAdmittanceTemplate: function () {
      this.$q.loading.show({
        message: 'Загрузка наряд-допуска...',
        messageColor: 'blue-11',
        spinnerColor: 'blue-11'
      })
      axiosGet({
        url: '/service/delta/orderadmittance/getFilledTemplate?brigadeId=' + this.orderAdmittance.brigadeId + '&templateId=' + this.orderAdmittance.templateId + (this.orderAdmittance.date ? '&date=' + this.orderAdmittance.date : ''),
        onSuccess: (response) => {
          this.orderAdmittance = this.convertFromServer(Object.assign(response.data.template, this.orderAdmittance))
          this.orderAdmittance.state = 'AD0'
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
          this.$q.loading.hide()
        },
        msgTarget: this
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    updateOrderAdmittance: function (emitUpdate = false) {
      this.$q.loading.show({
        message: 'Загрузка наряд-допуска...',
        messageColor: 'blue-11',
        spinnerColor: 'blue-11'
      })
      axiosGet({
        url: '/service/delta/orderadmittance/get?id=' + this.orderAdmittance.id,
        onSuccess: (response) => {
          this.orderAdmittance = this.convertFromServer(response.data.result)
          this.orderAdmittanceStr = JSON.stringify(this.orderAdmittance)
        },
        onFailure: 'Ошибка загрузки наряд-допуска',
        msgTarget: this
      }).finally(() => {
        this.$q.loading.hide()
      })

      if (this.isMobile && emitUpdate) {
        this.$emit('update')
      }
    },
    convertFromServer: function (orderAdmittance) {
      if (!orderAdmittance.closingEmployee) {
        this.$set(orderAdmittance, 'closingEmployee', {})
      }
      this.$set(orderAdmittance.closingEmployee, 'time', orderAdmittance.closingEmployee && orderAdmittance.closingEmployee.time)

      this.$set(orderAdmittance, 'prolongingEmployee', {})
      this.$set(orderAdmittance.prolongingEmployee, 'limit', null)

      return orderAdmittance
    },
    close: function () {
      if (window.history.length != 1 && window.history.state !== null) {
        this.$router.back()
      } else {
        this.$router.push('/')
      }
      if (this.orderAdmittance.brigadeId) {
        EventBus.$emit('update-brigade', +this.orderAdmittance.brigadeId)
      }
    }
  }
}

